var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#4A154B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4836 26.4361C15.4836 27.9486 14.2638 29.1693 12.7525 29.1693C11.2412 29.1693 10.0215 27.9445 10.0215 26.4361C10.0215 24.9277 11.2412 23.7029 12.7525 23.7029H15.4836V26.4361ZM16.847 26.4361C16.847 24.9236 18.0668 23.7029 19.5781 23.7029C21.0894 23.7029 22.3091 24.9236 22.3091 26.4361V33.267C22.3091 34.7795 21.0894 36.0002 19.5781 36.0002C18.0668 36.0002 16.847 34.7795 16.847 33.267V26.4361Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5771 15.4666C18.0658 15.4666 16.8461 14.2459 16.8461 12.7334C16.8461 11.2209 18.0658 10.0002 19.5771 10.0002C21.0884 10.0002 22.3082 11.2209 22.3082 12.7334V15.4666H19.5771ZM19.5771 16.8517C21.0884 16.8517 22.3082 18.0724 22.3082 19.5849C22.3082 21.0974 21.0884 22.3181 19.5771 22.3181H12.731C11.2197 22.3181 10 21.0933 10 19.5849C10 18.0765 11.2197 16.8517 12.731 16.8517H19.5771Z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5169 19.5849C30.5169 18.0724 31.7367 16.8517 33.248 16.8517C34.7593 16.8517 35.979 18.0724 35.979 19.5849C35.979 21.0974 34.7593 22.3181 33.248 22.3181H30.5169V19.5849ZM29.1535 19.5849C29.1535 21.0974 27.9338 22.3181 26.4224 22.3181C24.9111 22.3181 23.6914 21.0974 23.6914 19.5849V12.7334C23.6914 11.2209 24.9111 10.0002 26.4224 10.0002C27.9338 10.0002 29.1535 11.2209 29.1535 12.7334V19.5849Z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4224 30.5338C27.9338 30.5338 29.1535 31.7545 29.1535 33.267C29.1535 34.7795 27.9338 36.0002 26.4224 36.0002C24.9111 36.0002 23.6914 34.7795 23.6914 33.267V30.5338H26.4224ZM26.4224 29.1693C24.9111 29.1693 23.6914 27.9486 23.6914 26.4361C23.6914 24.9236 24.9111 23.7029 26.4224 23.7029H33.2685C34.7798 23.7029 35.9996 24.9236 35.9996 26.4361C35.9996 27.9486 34.7798 29.1693 33.2685 29.1693H26.4224Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.38c095bc19476289a12213f9900f09bb.svg";
export { ForwardRef as ReactComponent };